var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrastShowerInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.364C9 10.372 7.433 12 5.5 12S2 10.372 2 8.364c0-2.696 1.923-4.892 2.919-5.848a.83.83 0 0 1 1.162 0C7.077 3.472 9 5.668 9 8.364Zm13 0C22 10.372 20.433 12 18.5 12S15 10.372 15 8.364c0-2.696 1.924-4.892 2.919-5.848a.83.83 0 0 1 1.162 0C20.076 3.472 22 5.668 22 8.364Zm-6.5 10C15.5 20.372 13.933 22 12 22s-3.5-1.628-3.5-3.636c0-2.696 1.924-4.892 2.919-5.848a.829.829 0 0 1 1.162 0c.995.956 2.919 3.152 2.919 5.848Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrastShowerInactive);
export default __webpack_public_path__ + "static/media/contrast-shower-inactive.c1fc7720aa3f58e89e59194696e855db.svg";
export { ForwardRef as ReactComponent };